import gridComponentBase from "@/components/grid/gridComponentBase.vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { TextValueItem } from "../../../models/TextValueItem";
import api from "@/services/api";
import { DocumentiPolizeItem } from "@/models/prodotti/documentiPolizeItem";
import permessi from "@/config/permessi";

const _ENDPONT = api.endpoint.POLIZZE.DOCUMENTI_POLIZZE;
@Component({})
export default class DocumentiPolize extends gridComponentBase {
	get PERMESSI(): string[] { return [permessi.BK.Prodotti.POLIZZE]; }
	@Prop({ default: () => null }) prodottoID: number;
	editItem: DocumentiPolizeItem = new DocumentiPolizeItem();
	showEditModal: boolean = false;
	editSubTitle: string = "";
	editTitle: string = "";
	kendop: any = kendo;

	showOnlyActive: boolean = false;

	tipiFile: TextValueItem[] = [];

	get columns(): Array<any> {
		return [
			{ field: "itemID", title: "ID", width: 20, filterable: false, hidden: true, headerCell: "myHeaderCellTemplate", editHide: true },
			{ field: "prodottoID", title: "ID", width: 20, filterable: false, hidden: true, values: [this.ItemID], headerCell: "myHeaderCellTemplate", editHide: true },
			{
				field: "tipoFileID",
				title: this.$i18n.t("generico.tipoFile").toString(),
				values: this.tipiFile,
				groupable: true,
				headerCell: "myHeaderCellTemplate",
				sortBy: "tipoFile",
				filterType: "select",
				itemsForFilter: this.tipiFile,
				editType: "select",
				editSource: this.tipiFile
			},
			{
				field: "nomeFile",
				title: this.$i18n.t("generico.file").toString(),
				width: 400,
				editable: true,
				type: "download-file",
				editType: "upload-file",
				headerCell: "myHeaderCellTemplate"
			},
			{ title: "file", width: 200, hidden: true, headerCell: "myHeaderCellTemplate" },
			{ field: "startDate", title: this.$i18n.t("generico.startDate").toString(), format: "{0:dd/MM/yyyy}", width: 150, headerCell: "myHeaderCellTemplate", type: "date" },
			{ field: "endDate", title: this.$i18n.t("generico.endDate").toString(), format: "{0:dd/MM/yyyy}", width: 100, headerCell: "myHeaderCellTemplate", type: "date" },
			{ field: "cancellato", title: this.$i18n.t("generico.nonAttivo").toString(), hidden: true, headerCell: "myHeaderCellTemplate", type: "boolean", filterType: "boolean" },
			{ field: "istanteModifica", title: "Ultima Modifica", width: 90, hidden: true, headerCell: "myHeaderCellTemplate", editDisabled: true, type: "datetime"},
			{ field: "utenteModifica", title: "Utente", width: 90, hidden: true, headerCell: "myHeaderCellTemplate", editDisabled: true},
			{ field: "note", title: "Note", type:"textarea", width: 90, hidden: true, headerCell: "myHeaderCellTemplate", editDisabled: true},
			
			{
				field: "_actions",
				title: " ",
				width: (this.canEdit ? 50 : 0) + (this.canDelete ? 50 : 0),
				cell: "defaultCellTemplate",
				type: "actions_list",
				filterable: false,
				headerCell: "myHeaderCellTemplate",
				hidden: (this.canEdit == false && this.canDelete == false)
			}
		];
	}

	created() {
		var self = this;
		this.take = 60;
		this.pageable.pageSize = 60;
		this.pageSize = 60;
		if (this.group) {
			this.group.map(group => (group.aggregates = this.aggregates));
		}
		this.group = this.group;

		var p = api.getDatiDropDown(api.endpoint.DROPDOWN.TIPI_FILE).then(res => (self.tipiFile = res));

		Promise.all([p])
			.then(responses => {
				self.getData();
			})
			.catch(err => {
				console.log(err);
			});
	}

	@Watch("showOnlyActive")
	onShowOnlyActiveChange(newValue: boolean) {
		const field = "cancellato";
		if (newValue) {
			this.filter.filters.push({
				field: field,
				operator: "eq",
				value: "!!false!!"
			});

			this.setDefaultPageSize();
			this.getData();
		} else {
			var findFilterIndex = this.filter.filters.findIndex(function (item) {
				return item.field === field;
			});

			this.filter.filters.splice(findFilterIndex, 1);

			this.setDefaultPageSize();
			this.getData();
		}
	}

	getData() {
		this.getGridData(`${_ENDPONT}/${this.prodottoID}`);
	}

	onDelete(item: any) {
		var self = this;
		var message = self.$createElement("div", { domProps: { innerHTML: `<h5>${item.ItemID}</h5>${self.$i18n.t("messaggio.confermaCancellazione")}` } }); // h('div', { domProps: { innerHTML: 'Title from <i>HTML<i> string' } })
		var title = this.$i18n.t("titolo.elimina", [this.$i18n.t("generico.documento")]).toString();
		self.deleteGridRow(_ENDPONT, item.itemID, title, [message]);
	}

	addNewRow() {
		let newItem = new DocumentiPolizeItem();
		newItem.prodottoID = this.prodottoID;

		this.onEdit(newItem);
	}

	onEdit(item: any) {
		var self = this;
		debugger;
		self.editItem = Object.assign(new DocumentiPolizeItem(), item);
		self.editSubTitle = "";
		self.editTitle = item.pacchettoID;
		self.showEditModal = true;
	}

	onSaveEdit() {
		var self = this;
		if (self.warningEditDocumentType) {
			var title = this.$i18n.t("generico.warning").toString();
			var message = this.$i18n.t("msg.confermaSalvataggioStessoTipoDocumento").toString();
			self.$bvModal
				.msgBoxConfirm(message, {
					title: title,
					okVariant: "warning",
					okTitle: self.$i18n
						.t("btn.si")
						.toString()
						.toUpperCase(),
					cancelTitle: self.$i18n
						.t("btn.no")
						.toString()
						.toUpperCase(),
					cancelVariant: "outline-theme",
					footerClass: "",
					headerBgVariant: "warning"
					// centered: true
				})
				.then(value => {
					if (value) {
						self.saveEdit();
					}
				})
				.catch(err => {
					// An error occurred
				});
		}
		else {
			self.saveEdit();
		}
	}

	saveEdit() {
		var self = this;
		var title = this.$i18n.t("msg.salvataggioRiuscito").toString();
		var message = this.$i18n.tc("msg.salvato_iCorrettamente", 1, { obj: this.$i18n.t("generico.documento") }).toString();
		api.setDocumentiPolizze(self.prodottoID, self.editItem)
			.then(res => {
				this.$bvToast.toast(message, {
					variant: "success",
					title: title,
					solid: true
				});

				self.getData();
				self.showEditModal = false;
			})
			.catch(err => {
				console.log(err);
			});
	}

	renderCellFile(data: string, dataItem: DocumentiPolizeItem) {
		var result = `<a href='~/CMSPages/GetFile.aspx?nodeguid=${dataItem.guidFile}' target='_blank'>${data}</a>`;
		return result;
	}

	get isNewItem(): boolean {
		return (this.editItem || {}).itemID == null || (this.editItem || {}).itemID <= 0;
	}

	get warningEditDocumentType(): boolean {
		var self = this;
		var item = self.editItem || new DocumentiPolizeItem();
		return item.nomeFile_uploadFile && ((self.itemsGrid || []) as Array<DocumentiPolizeItem>).some(x => x.tipoFileID == item.tipoFileID && x.itemID != item.itemID)
	}
}
